module.exports = __webpack_public_path__ + "static/img/s59.71058039.png";